import React from 'react';
import { PhoneIcon, SendIcon } from 'lucide-react';
export function ContactCTA() {
  return <section className="bg-[#0a1628] text-white py-16 px-4 md:px-8" data-id="element-37">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-38">
        {/* Left Side (Text) */}
        <div className="text-center lg:text-right" data-id="element-39">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black mb-6 leading-tight" data-id="element-40">
            מוכנים לפתור <br data-id="element-41" />
            את הבעיה?
          </h2>

          <div className="mb-6" data-id="element-42">
            <div className="flex flex-col gap-1 mb-4" data-id="element-43">
              <a href="tel:0523552222" className="block text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-44">
                <span dir="ltr" data-id="element-45">052-355-2222</span>
              </a>
              <a href="tel:0545188888" className="block text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-46">
                <span dir="ltr" data-id="element-47">054-518-8888</span>
              </a>
            </div>
            <div className="inline-block bg-orange-500/20 text-orange-300 px-4 py-2 rounded-full text-base font-bold border border-orange-500/30" data-id="element-48">
              ⚡ מגיעים תוך שעה – 24/7
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-6 max-w-lg mx-auto lg:mx-0" data-id="element-49">
            אל תתנו לרטיבות להתפשט. שיחת ייעוץ אחת יכולה לחסוך לכם אלפי שקלים
            ועוגמת נפש.
          </p>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-50">
            <a href="tel:0523552222" className="inline-flex items-center justify-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-6 py-4 text-lg font-bold rounded-lg shadow-lg transition-all transform hover:scale-105" data-id="element-51">
              <PhoneIcon className="w-5 h-5" data-id="element-52" />
              052-355-2222
            </a>
            <a href="tel:0545188888" className="inline-flex items-center justify-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-6 py-4 text-lg font-bold rounded-lg shadow-lg transition-all transform hover:scale-105" data-id="element-53">
              <PhoneIcon className="w-5 h-5" data-id="element-54" />
              054-518-8888
            </a>
          </div>
        </div>

        {/* Right Side (Form) */}
        <div className="bg-white text-gray-900 p-6 md:p-8 rounded-2xl shadow-2xl w-full" data-id="element-55">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-56">
            השאירו פרטים ונחזור אליכם
          </h3>

          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-57">
            <div data-id="element-58">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59">
                שם מלא
              </label>
              <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="ישראל ישראלי" data-id="element-60" />
            </div>

            <div data-id="element-61">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-62">
                טלפון
              </label>
              <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="050-000-0000" data-id="element-63" />
            </div>

            <div data-id="element-64">
              <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-65">
                עיר מגורים
              </label>
              <input type="text" id="city" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all" placeholder="לדוגמה: תל אביב" data-id="element-66" />
            </div>

            <div data-id="element-67">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-68">
                תיאור הבעיה (אופציונלי)
              </label>
              <textarea id="message" rows={3} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#f97316] focus:border-transparent outline-none transition-all resize-none" placeholder="יש לי רטיבות בתקרה..." data-id="element-69"></textarea>
            </div>

            <button type="submit" className="w-full bg-[#f97316] hover:bg-orange-600 text-white font-bold py-4 rounded-lg shadow-md transition-all flex items-center justify-center gap-2 text-lg mt-2" data-id="element-70">
              שלחו פרטים – נחזור תוך 10 דקות
              <SendIcon className="w-5 h-5" data-id="element-71" />
            </button>
          </form>

          <div className="text-center mt-6 pt-6 border-t border-gray-100" data-id="element-72">
            <p className="text-gray-500 text-sm mb-2" data-id="element-73">או התקשרו ישירות:</p>
            <div className="flex flex-col gap-1" data-id="element-74">
              <a href="tel:0523552222" className="text-2xl font-black text-[#0a1628] hover:text-[#f97316]" data-id="element-75">
                052-355-2222
              </a>
              <a href="tel:0545188888" className="text-2xl font-black text-[#0a1628] hover:text-[#f97316]" data-id="element-76">
                054-518-8888
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}